import { render, staticRenderFns } from "./busbuttons-add-or-update.vue?vue&type=template&id=d818bfb8&scoped=true&"
import script from "./busbuttons-add-or-update.vue?vue&type=script&lang=js&"
export * from "./busbuttons-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./busbuttons-add-or-update.vue?vue&type=style&index=0&id=d818bfb8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d818bfb8",
  null
  
)

export default component.exports